<h1>{{ "CONFIGURATION_AREA.TITLE" | translate }}</h1>
<ene-icon (click)="closeConfigurationArea()" icon="ec_building_delete_address"></ene-icon>
